/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalPricePointAllocation
 */
export interface LocalPricePointAllocation {
    /**
     * 
     * @type {Date}
     * @memberof LocalPricePointAllocation
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof LocalPricePointAllocation
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof LocalPricePointAllocation
     */
    createdByUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof LocalPricePointAllocation
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalPricePointAllocation
     */
    priceUnitId?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalPricePointAllocation
     */
    localRecommendedRetailPricePoint?: number;
}

/**
 * Check if a given object implements the LocalPricePointAllocation interface.
 */
export function instanceOfLocalPricePointAllocation(value: object): value is LocalPricePointAllocation {
    return true;
}

export function LocalPricePointAllocationFromJSON(json: any): LocalPricePointAllocation {
    return LocalPricePointAllocationFromJSONTyped(json, false);
}

export function LocalPricePointAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalPricePointAllocation {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdByUserId': json['createdByUserId'] == null ? undefined : json['createdByUserId'],
        'year': json['year'] == null ? undefined : json['year'],
        'priceUnitId': json['priceUnitId'] == null ? undefined : json['priceUnitId'],
        'localRecommendedRetailPricePoint': json['localRecommendedRetailPricePoint'] == null ? undefined : json['localRecommendedRetailPricePoint'],
    };
}

export function LocalPricePointAllocationToJSON(json: any): LocalPricePointAllocation {
    return LocalPricePointAllocationToJSONTyped(json, false);
}

export function LocalPricePointAllocationToJSONTyped(value?: LocalPricePointAllocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
        'createdByUserId': value['createdByUserId'],
        'year': value['year'],
        'priceUnitId': value['priceUnitId'],
        'localRecommendedRetailPricePoint': value['localRecommendedRetailPricePoint'],
    };
}

